import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { USER_QUERIES } from '@/app/platform/platform-core/user/store/types';
import { hasFeature } from '@/app/support/support-access.service';
import { HdChartSettingsStore } from '../chart/bodygraph/chart-tabs/hd-chart-settings.store';
import { CommunityContentAccessService } from '../community-content/community-content-access.service';
import { CLASSIC_ICHING_FEATURE_ID } from './iching.metadata';

/**
 * Toegang tot Classic I Ching: twee sloten die allebei nodig zijn. De
 * UPAM-feature bepaalt of het onderdeel bestaat (settings-rij, iconen, pagina);
 * de setting is de keuze van de gebruiker. Een setting die aan staat terwijl
 * de feature later is ingetrokken telt niet: alles loopt via `classicVisible()`.
 */
@Injectable({ providedIn: 'root' })
export class HdIChingAccessService {
  // Optioneel: in component-specs zonder user-store is er simpelweg geen
  // toegang, in plaats van een injectiefout.
  private readonly userQueries = inject(USER_QUERIES, { optional: true });
  private readonly settings = inject(HdChartSettingsStore);
  private readonly community = inject(CommunityContentAccessService);

  readonly featureGranted: Signal<boolean> = this.granted(CLASSIC_ICHING_FEATURE_ID);
  readonly classicVisible = computed(() => this.featureGranted() && this.settings.classicIChingEnabled());
  /** Nederlandse Wilhelm-tekst beschikbaar (pack-feature)? */
  readonly wilhelmNlAvailable = computed(() => this.community.wilhelmNlGranted());

  private granted(featureId: string): Signal<boolean> {
    if (this.userQueries == null) {
      return computed(() => false);
    }
    return toSignal(
      combineLatest([this.userQueries.isAnyUserAuthenticated$, this.userQueries.availableApps$]).pipe(
        map(([authenticated, apps]) => authenticated && hasFeature(apps, featureId)),
      ),
      { initialValue: false },
    );
  }
}
